package de.oevbs.kunde.kundenportal2.services.inbox

import de.oevbs.businesspartner.bpcrmservice2.common.model.LineOfBusiness
import de.oevbs.kosmos.ui.elements.button.btn
import de.oevbs.kosmos.ui.elements.spinner
import de.oevbs.kosmos.ui.forms.inputgroup.inputText
import de.oevbs.kosmos.ui.forms.selectmenu.selectMenu
import de.oevbs.kosmos.ui.icons.LineOfBusinessIcons
import de.oevbs.kosmos.ui.icons.MaterialIconsOutlined
import de.oevbs.kunde.kundenportal2.Pages.inboxInbox
import de.oevbs.kunde.kundenportal2.components.*
import de.oevbs.kunde.kundenportal2.lineOfBusinessToString
import de.oevbs.kunde.kundenportal2.model.services.inbox.*
import de.oevbs.sfa.data.time.toLocalizedString
import dev.fritz2.core.RenderContext
import dev.fritz2.core.mapByElement
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.map


fun RenderContext.inbox() {
    headerImageLayout {
        title(inboxInbox.linkTitle)
        content {
            contentContainer {
                val inboxStore = InboxStore(job)
                inboxStore.loadFirstTwoYears(Unit)

                globalInitTracker.data.combine(inboxStore.initFailedFlow, ::Pair).render { (loading, failed) ->
                    if (loading) return@render
                    when {
                        failed -> noPartnerDataFoundMessage()
                        else -> {
                            renderFilter()
                            renderMessages(inboxStore)
                            renderMoreButton(inboxStore)
                        }
                    }
                }
            }
        }
    }
}

private fun RenderContext.renderFilter() = div("flex flex-col md:flex-row gap-2 md:gap-6 md:justify-end") {
    selectMenu<LineOfBusiness> {
        value(FilterStore.map(InboxFilter.sparte()))
        options = LineOfBusiness.all
        optionsFormat = ::lineOfBusinessToString
    }
    div("w-full md:w-60") {
        inputText {
            value(FilterStore.map(InboxFilter.pattern()))
            readOnly(FilterStore.data.map { it.patternState == PatternState.Readonly })
            iconClickable(FilterStore.data.map {
                if (it.patternState == PatternState.Active) MaterialIconsOutlined.search else MaterialIconsOutlined.delete
            }) {
                clicks handledBy FilterStore.toggleState
            }
        }
    }
}

private fun RenderContext.renderMessages(inboxStore: InboxStore) = div("space-y-1") {
    inboxStore.filteredData.renderEach(Message::id, into = this) { message ->
        val (storedMessage, setRead) = inboxStore.mapByElement(message, Message::id).run {
            this to handle { msg -> msg.copy(read = true) }
        }

        collapsible("mailbox-${message.id}") {
            headerLeft(
                message.subject,
                MaterialIconsOutlined.mail,
                MaterialIconsOutlined.drafts
            )

            message.claimNo?.let { if (it.isNotBlank()) headerRight(it, MaterialIconsOutlined.water_damage) }
            if (message.lineOfBusiness != LineOfBusiness.Unbekannt) headerRight(
                message.lineOfBusiness.title,
                LineOfBusinessIcons.valueOf(message.lineOfBusiness.value)
            )
            if (!message.contractNo.isNullOrBlank()) headerRight(message.contractNo!!, MaterialIconsOutlined.book_2)
            headerRight(message.date.toLocalizedString(), MaterialIconsOutlined.calendar_today)

            content {
                div("vui-label-4 whitespace-pre-line") {
                    renderLoadDetailsSpinner(message.id, inboxStore)
                    storedMessage.data.render { msg ->
                        if (msg.detailsLoaded) +msg.detailText.orEmpty()
                    }
                }
                if (message.docLinks.isNotEmpty()) {
                    p("mb-3") {
                        div("vui-label-3 mb-2") { +"Downloads" }
                        div("text-sm") { +"Safari-Benutzer: Bitte erlauben Sie Popups in Ihren Browser-Einstellungen, da sich die Downloads in einem neuen Fenster öffnen." }
                    }
                    div("flex flex-col lg:flex-row gap-2 items-start") {
                        message.docLinks.forEach { pdfDownloadButton(it) }
                    }
                }
            }

            isRead(storedMessage.data.map { it.read })
            handleToggle {
                if (it) {
                    setRead(Unit)
                    inboxStore.loadDetails(message.guid)
                }
            }
        }
    }
}

private fun RenderContext.renderLoadDetailsSpinner(outerMessageId: String, inboxStore: InboxStore) =
    inboxStore.loadDetailsData.renderIf({ (tracking, messageId) ->
        tracking && messageId == outerMessageId
    }) {
        spinner("spinner-8")
    }

private fun RenderContext.renderMoreButton(inboxStore: InboxStore) {
    buttonContainer {
        btn {
            label(StoredNextYear.data.map { "$it anzeigen" })
            busy(inboxStore.loadingMore, StoredNextYear.data.map { "Lade $it..." })
        }.clicks.map { StoredNextYear.current } handledBy inboxStore.loadMore
    }
}